(function () {
  'use strict';

  // State must be attached to the window object. When pagination appends new products,
  // the script tag might be re-evaluated by the browser, which creates a new closure.
  window._cpsCurrentPath = window._cpsCurrentPath || window.location.pathname;
  window._cpsPeekPlayed = window._cpsPeekPlayed || false;
  window._cpsFirstCardDone = window._cpsFirstCardDone || false;

  function runPeekAnimation(swiper, swiperEl) {
    if (window._cpsPeekPlayed) return;
    window._cpsPeekPlayed = true;

    var SPEED = 480;
    var HOLD = 220;
    var REPEATS = 3;
    var count = 0;

    function doPeek() {
      if (count >= REPEATS) return;
      count++;

      var baseTranslate = swiper.translate;
      var peekOffset = swiper.width * 0.5;

      swiper.setTransition(SPEED);
      swiper.setTranslate(baseTranslate - peekOffset);

      setTimeout(function () {
        swiper.setTransition(SPEED);
        swiper.setTranslate(baseTranslate);

        setTimeout(doPeek, SPEED + HOLD);
      }, SPEED + HOLD);
    }

    // Delay peek slightly to ensure images are ready
    setTimeout(doPeek, 800);
  }

  /* ── Initialise a single card ── */
  function initCard(linkEl) {
    if (linkEl.dataset.cpsReady === 'true') return;
    linkEl.dataset.cpsReady = 'true';

    // 1. Gather all URLs from data-cps-images
    var hoverImagesStr = linkEl.getAttribute('data-cps-images') || '';
    var images = hoverImagesStr.split(',').filter(Boolean);

    // 2. Extract ONLY the primary image to avoid duplicates
    var primaryImgEl = linkEl.querySelector('.product-primary-image');
    if (primaryImgEl) {
      var srcset = primaryImgEl.getAttribute('data-srcset') || primaryImgEl.getAttribute('srcset') || '';
      var primaryUrl = '';
      if (srcset) {
        // Extract the largest resolution URL from srcset (usually the last one)
        var srcsetParts = srcset.split(',');
        var largestPart = srcsetParts[srcsetParts.length - 1].trim();
        primaryUrl = largestPart.split(' ')[0];
      }
      if (!primaryUrl) {
        primaryUrl = primaryImgEl.getAttribute('data-src') || primaryImgEl.getAttribute('src') || '';
      }
      if (primaryUrl && primaryUrl.indexOf('placeholder') === -1) {
        images.unshift(primaryUrl); // Add primary image to the beginning
      }
    }

    var oldVideos = linkEl.querySelectorAll('video, iframe');
    var mediaSlidesHTML = '';
    oldVideos.forEach(function (video) {
        video.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
        mediaSlidesHTML += '<div class="swiper-slide">' + video.outerHTML + '</div>';
        video.remove();
    });

    // If only 1 image exists, do not initialize Swiper at all!
    if (images.length <= 1 && mediaSlidesHTML === '') {
       return;
    }

    var slidesHTML = images.map(function (url) {
        // Strip Shopify CDN parameters to get pure URL, or just use it raw
        return (
            '<div class="swiper-slide">' +
            '<img ' +
            'src="' + url + '" ' +
            'loading="lazy" ' +
            'style="width:100%;height:100%;object-fit:cover;display:block;" ' +
            '/>' +
            '</div>'
        );
    }).join('');

    slidesHTML = mediaSlidesHTML + slidesHTML;
    
    var uid = 'cps-' + Math.random().toString(36).slice(2, 7);

    var swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper cps-swiper';
    swiperWrapper.id = uid;
    swiperWrapper.innerHTML = '<div class="swiper-wrapper">' + slidesHTML + '</div>';
    
    var paginEl = document.createElement('div');
    paginEl.id = uid + '-pagination';
    paginEl.className = 'swiper-pagination cps-ext-pagination';

    var prevEl = document.createElement('div');
    prevEl.id = uid + '-prev';
    prevEl.className = 'swiper-button-prev cps-ext-nav';

    var nextEl = document.createElement('div');
    nextEl.id = uid + '-next';
    nextEl.className = 'swiper-button-next cps-ext-nav';

    // Clean up all native Shopify elements
    linkEl.style.position = 'relative';
    linkEl.style.overflow = 'hidden';
    var oldMedia = linkEl.querySelectorAll('img, video, picture, iframe, .thb-placeholder, .product-secondary-images-nav, .product-featured-image__shimmer');
    oldMedia.forEach(function (media) { media.remove(); });

    linkEl.appendChild(swiperWrapper);
    linkEl.appendChild(paginEl);
    linkEl.appendChild(prevEl);
    linkEl.appendChild(nextEl);

    if (window.location.pathname !== window._cpsCurrentPath) {
      window._cpsCurrentPath = window.location.pathname;
      window._cpsFirstCardDone = false;
      window._cpsPeekPlayed = false;
    }

    var isFirstCard = false;
    if (!window._cpsFirstCardDone) {
      isFirstCard = true;
      window._cpsFirstCardDone = true;
    }

    new window.Swiper('#' + uid, {
        loop: true,
        speed: 400,
        autoplay: false,
        slidesPerView: 1,
        grabCursor: true,
        preventInteractionOnTransition: false,
        pagination: {
            el: '#' + uid + '-pagination',
            clickable: true
        },
        navigation: {
            prevEl: '#' + uid + '-prev',
            nextEl: '#' + uid + '-next',
        },
        on: {
            init: function (swiper) {
                if (isFirstCard) {
                    runPeekAnimation(swiper, swiperWrapper);
                }
            }
        }
    });
  }

  /* ── Observe & initialise all cards ── */
  function initAll() {
    document.querySelectorAll('[data-cps="true"]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var cpsTimeout;
  new MutationObserver(function() {
    clearTimeout(cpsTimeout);
    cpsTimeout = setTimeout(initAll, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
